<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit = true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">导入新模板 </el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 261px)" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="title" label="名称" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTeacher" label="创建人" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column label="操作" width="230px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="viewSms(row)" icon="el-icon-edit" type="primary" :underline="false">查看短信</el-link>
              <el-popconfirm title="确定要删除此模板吗？" @onConfirm="removeSMS(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <el-dialog
      title="导入学生迎新模板"
      :visible.sync="showEdit"
      width="500px"
      @closed="editForm = { title: '', file: null }"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-row :gutter="15">
          <el-col>
            <el-form-item label="名称:" prop="title">
              <el-input v-model="editForm.title" placeholder="请输入名称" clearable />
            </el-form-item>
            <el-form-item label="模板上传:" prop="file">
              <el-upload
                action=""
                :before-upload="beforeUpload"
                :on-change="handleUpload"
                :file-list="fileList"
                class="ele-block"
                drag
                accept=".xls,.xlsx"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text"> 将文件拖到此处，或 <em>点击上传</em> </div>
                <div class="el-upload__tip ele-text-center" slot="tip">
                  只能上传xls、xlsx文件，
                  <el-link
                    type="primary"
                    :underline="false"
                    href="https://hdsys.oss-cn-beijing.aliyuncs.com/hdjxt/template/1644808109607/迎新学生信息导入 .xlsx"
                    download
                    style="vertical-align: baseline"
                    >下载模板
                  </el-link>
                </div>
              </el-upload>
              <!--              <div>模板展示说明</div>-->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看短信" :visible.sync="showSMS" width="70%">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="sendSms" type="primary" icon="el-icon-s-promotion" class="ele-btn-icon" size="small">发送短信</el-button>
      </div>
      <ele-data-table ref="coreTable" :config="smsTable" :data="smsData" height="calc(90vh - 261px)" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="studentName" label="学生姓名" sortable="custom" show-overflow-tooltip width="110" align="center" />
          <el-table-column prop="mobile" label="手机号" sortable="custom" show-overflow-tooltip width="110" align="center" />
          <el-table-column prop="text" label="短信内容" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTeacher" label="创建人" sortable="custom" show-overflow-tooltip width="110" align="center" />
          <el-table-column label="发送状态" show-overflow-tooltip width="100" align="center">
            <template #default="{ row }">
              <el-tag :type="row.sendType == 0 ? 'danger' : row.sendType == 1 ? 'success' : ''" effect="dark">
                {{ row.sendType == 0 ? '未发送' : row.sendType == 1 ? '已发送' : '' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip width="220" align="center" />
        </template>
      </ele-data-table>
    </el-dialog>
  </div>
</template>

<script>
  import { deleteNewStudenteTemplate, importNewStudentExcel, sendNewStudentSMS, showNewStudentSMS } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        table: {
          // 成绩表格配置
          url: '/school/newStudent/showNewStudenteTemplate',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            // res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 导入成绩表格选中数据
        showEdit: false, // 导入成绩弹窗
        editForm: {
          title: '',
          file: null,
        },
        editRules: {
          // 表单验证规则
          title: [{ required: true, message: '请输入考试名称', trigger: 'blur' }],
        },
        uploadLoading: false,
        fileList: [],
        showSMS: false,
        smsTable: {
          page: false,
        },
        smsData: [],
        templateId: null,
      };
    },
    methods: {
      //成绩导入之前
      beforeUpload(file) {
        this.editForm.file = file;
        return false;
      },
      // 监听导入变化
      handleUpload(file, fileList) {
        this.fileList = fileList.slice(-1);
        return false;
      },
      // 导入模板
      save() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            importNewStudentExcel(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.showEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },

      viewSms(row) {
        this.templateId = row.id;
        let data = {
          id: row.id,
        };
        showNewStudentSMS(data).then((res) => {
          if (res.data.resCode == 200) {
            this.smsData = res.data.data;
          }
        });
        this.showSMS = true;
      },
      sendSms() {
        let data = {
          id: this.templateId,
        };
        sendNewStudentSMS(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            showNewStudentSMS(data).then((res) => {
              if (res.data.resCode == 200) {
                this.smsData = res.data.data;
              }
            });
          } else {
            this.$message.error(res.data.resMsg || '获取数据失败');
          }
        });
      },
      removeSMS(row) {
        deleteNewStudenteTemplate({ id: row.id }).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
